import { createFooter, initDictionaryCatalog } from '@wg/wows-common-footer/main';
import { IFooterProps, Realm } from '@wg/wows-common-footer/types';
import { useEffect, useRef } from 'react';

import preloaded from '~/preloaded';

import styles from './Footer.scss';

const Footer = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    async function initFooter() {
      await initDictionaryCatalog({
        language: preloaded.settings.languageCode,
        dictionaryCatalog: window.i18n.catalog,
      });

      const options: IFooterProps = {
        selector: '#footer-container',
        language: preloaded.settings.languageCode,
        realm: preloaded.settings.realm as Realm,
        version: '',
        dictionaryCatalog: window.i18n.catalog,
        rootUrl: null,
        onLanguageChange: ({ realm, language }) => {
          location.href = `${preloaded.settings.realmsMap[realm]}/?lang=${language}`;
        },
        onClickByLink: (event: MouseEvent) => {
          event.preventDefault();
          const target = event.currentTarget as HTMLLinkElement;
          if (target.id !== 'ot-sdk-btn') {
            window.open(target.href, '_blank');
          }
        },
      };

      if (preloaded.settings.realm === 'cn360') {
        options.realms = [];
      }

      createFooter(options);

      if (window.OneTrust) {
        window.OneTrust.initializeCookiePolicyHtml();
      }
    }

    initFooter();
  }, []);

  useEffect(() => {
    if (!(ref.current instanceof Element)) {
      return;
    }

    const observer = new MutationObserver(() => {
      const element = document.getElementById('ot-sdk-btn');
      if (element && window.OneTrust) {
        observer.disconnect();

        window.OneTrust?.initializeCookiePolicyHtml?.();
      }
    });

    observer.observe(ref.current, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return <div ref={ref} id={'footer-container'} className={styles.footer} />;
};

export default Footer;
